<template>
  <div v-if="show" class="modal-mask" @click.self="fechar">
    <div class="modal-wrapper">
      <div class="modal-container">
        <h3>Editar Lançamento</h3>

        <div class="modal-body">
          <div class="container" style="overflow: auto; max-height: 60vh;">
            <div class="row">
              <div class="col-12" v-show="meta">
                <label class="lblselect2">Objetivo da meta:</label>
                <select id="cbmeta" v-model="vidmeta" class="form-control">
                </select>
              </div>
              <div class="col-12" v-show="parseInt(vtipolanca) === 1">
                <label class="lblselect2">Buscar receita pré-definida:</label>
                <select id="cbreceita" v-model="vidreceitadespesa" class="form-control">
                </select>
              </div>
              <div class="col-12" v-show="parseInt(vtipolanca) === 2">
                <label class="lblselect2">Buscar despesa pré-definida:</label>
                <select id="cbdespesa" v-model="vidreceitadespesa" class="form-control">
                </select>
              </div>
              <div class="col-12">
                <label for="eddtlanca">Dt. Lancto:</label>
                <date-picker class="form-control" v-model="vdtlanca" id="eddtlanca" format="DD/MM/YYYY"
                  value-type="DD/MM/YYYY" />
              </div>
              <div class="col-12 mt-2">
                <label for="cbqtdreg">Tipo:</label>
                <select name="cbqtdreg" id="cbqtdreg" v-model="vtipolanca" @change="mtdmudatipolanca" class="form-control"
                  :style="parseInt(vtipolanca) === 1 ? 'background-color: darkgreen; color: white' : 'background-color: crimson; color: white'">
                  <option value="1" style="background-color: darkgreen; color: white">Receita</option>
                  <option value="2" style="background-color: crimson; color: white">Despesa</option>
                </select>
              </div>
              <div class="col-12 mt-2">
                <label class="lblselect2">
                  *{{ parseInt(vtipolanca) === 2 ? 'Sai da' : 'Entra na' }} conta:
                  (saldo {{ mtdformatavalordecimal(saldoconta, 'R$') }})
                </label>
                <select id="cbconta" v-model="vidconta" class="form-control">
                </select>
              </div>
              <div class="col-12 mt-2" v-show="parseInt(vtipolanca) === 1">
                <label class="lblselect2">Categoria (Receita):</label>
                <select id="cbcategoriareceita" v-model="vidreceitadespesa" class="form-control">
                </select>
              </div>
              <div class="col-12 mt-2" v-show="parseInt(vtipolanca) === 2">
                <label class="lblselect2">*Categoria (Despesa):</label>
                <select id="cbcategoriadespesa" v-model="vidcategoria" class="form-control">
                </select>
              </div>
              <div class="col-12 mt-2" >
              <label for="desclancto" class="form-label">Descrição</label>
                <input type="text" v-model="vdescricaolanto" id="desclancto" class="form-control" placeholder="Uma pequena descrição de seu lançamento"  >
              </div>
              <div class="col-12 mt-2">
                <label for="cbvalor">Valor:</label>
                <money id="cbvalor" v-model="valorlanca" v-bind="money" class="form-control text-end"></money>
              </div>
            </div>
          </div>
        </div>

        <!-- eslint-disable  -->
        <div class="modal-footer">
          <button @click="salvar" class="btn btn-primary btn-sm" style="background-color: black; color: aliceblue;">Salvar</button>
          <button @click="excluir"class="btn btn-danger btn-sm" style="background-color: brown; color: aliceblue">Excluir</button>
          <button @click="fechar" class="btn btn-secondary btn-sm">Cancelar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Swal from 'sweetalert2'
import util from '../util.js';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/pt-br';
export default {
  name: 'ModalLancamento',
  components: {
    DatePicker
  },
  props: {
    show: Boolean,
    lancamento: Object
  },
  data() {
    return {
      editLancamento   : {},
      vopcrudlancto    : 0, 
      vid              : 0,
      vtipolanca       : 0,
      vidreceitadespesa: null,
      vidconta         : null,
      saldoconta       : 0,
      vidcategoria     : null,
      valorlanca       : 0,
      meta             : false,
      vidmeta          : null,
      vdtlanca         : this.mtdpegadataatual(),
      vdescricaolanto  : '',
      isMobile         : false,

      valor_anterior   : 0,
      idconta_anterior : 0,
      tipo_anterior    : 0,


      money: {
        decimal  : ',',
        thousands: '.',
        prefix   : '',//aqui colocar o cifrão se for necessário
        precision: 2,
        masked   : false
      },
      options: {
        format: 'DD/MM/YYYY',
        useCurrent: false,
        locale: 'pt-BR'
      },
    }
  },
  watch: {
    lancamento: {
      handler(val) {
        this.editLancamento = Object.assign({}, val) // Cópia para edição
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    mtdformatavalordecimal(valor, digitos) {
      return util.formatarvalor(valor, digitos);
    },
    mtdpegadataatual() {
      const dataAtual = new Date();
      const dia       = String(dataAtual.getDate()).padStart(2, '0'); // Dia com dois dígitos
      const mes       = String(dataAtual.getMonth() + 1).padStart(2, '0'); // Mês com dois dígitos (lembrando que getMonth() retorna de 0 a 11)
      const ano       = dataAtual.getFullYear();
      return `${dia}/${mes}/${ano}`;
    },
    salvar() {
      let vself = this;
      
      if(!this.vidcategoria){
        util.notif('error', 'Informação!', "Informe uma categoria!");
        return;
      }

      if(!this.vidconta){
        util.notif('error', 'Informação!', "Informe uma conta!");
        return;
      }

      if(parseFloat(this.valorlanca)  === 0){
        util.notif('error', 'Informação!', "Informe um valor para o lançamento!");
        return;
      }
      
      Swal.fire({
          title: "Confirmação",
          text: 'Deseja salvar o movimento?',
          icon: "warning",
          customClass: {
            confirmButton: "conf btn btn-success",
            cancelButton: "btn btn-danger"
          },
          showCancelButton: true,
          confirmButtonColor: "black",
          cancelButtonText: "Não",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim"

        }).then((result) => {
          if (result.isConfirmed) {
            $('.conf').prop('disabled', true);
            vself.mtdregistro(2);
          } else {
            $('#btgravar').focus();
          }
        });
    },
    excluir() {
      let vself = this
      Swal.fire({
        title: "Confirmação",
        text: 'Deseja ecluir o movimento?',
        icon: "warning",
        customClass: {
          confirmButton: "conf btn btn-success",
          cancelButton: "btn btn-danger"
        },
        showCancelButton: true,
        confirmButtonColor: "black",
        cancelButtonText: "Não",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim"

      }).then((result) => {
        if (result.isConfirmed) {
          $('.conf').prop('disabled', true);
          vself.mtdregistro(3);
        } else {
          $('#btgravar').focus();
        }
      });
    },
    fechar() {
      this.$emit('fechar')
    },
    
    mtdregistro(op) {
      let vself = this;

      let registro = {
        'id'              : this.vid,
        'valor'           : this.valorlanca,
        'idcategoria'     : this.vidcategoria,
        'tipo'            : this.vtipolanca,
        'descricao'       : this.vdescricaolanto,
        'idmeta'          : this.vidmeta === null ? 0 : this.vidmeta,
        'idreceitapre'    : this.vidreceitadespesa === null ? 0 : this.vidreceitadespesa,
        'idconta'         : this.vidconta,
        'dtlancamento'    : this.vdtlanca,

        'valor_anterior'  : this.valor_anterior,
        'idconta_anterior': this.idconta_anterior,
        'tipo_anterior'   : this.tipo_anterior,
      };

      let parametros = [
        { parametro: 'op',        valor: 'rotinacrud' },
        { parametro: 'registro',  valor: JSON.stringify(registro) },
        { parametro: 'opcrud',    valor: op },
        { parametro: 'idusuario', valor: localStorage.getItem('iduser') },
      ];
      let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/cadlancamento.php');
      retorno.then(function (response) {
        if ($.isNumeric(response.data)) {
          util.notif('success', 'Informação!', 'Registro processado com sucesso!');
          vself.$emit('fechar');
        } else {
          let tpret = response.data.substring(0, 1);
          switch (tpret) {
            case 'I':
              util.notif('error', 'Informação!', response.data.substring(4));
              break;
            case 'E': default:
              util.notif('error', 'Informação!', response.data.substring(4));
              break;
          }
        }
      }).catch(function (response) {
        
      });
    },
    igualardados(){
        this.vid              = this.editLancamento.id;

        this.vtipolanca       = parseInt(this.editLancamento.tipo) === 0 ? 2 : 1;
        this.vidreceitadespesa= this.editLancamento.idreceitapre;
        //this.vidreceita
        this.vidconta         = this.editLancamento.idconta;
        this.saldoconta       = this.editLancamento.saldoconta;
        this.vidcategoria     = this.editLancamento.idcategoria;
        this.valorlanca       = parseFloat(this.editLancamento.valor);

        this.valor_anterior   = parseFloat(this.editLancamento.valor);
        this.idconta_anterior = this.editLancamento.idconta;
        this.tipo_anterior    = this.vtipolanca;

        
        if(parseInt(this.editLancamento.idmeta) > 0){
          this.meta             = true
          this.vidmeta          = this.editLancamento.idmeta;

          var defmeta  = new Option(this.editLancamento.descmeta,  this.vidmeta, true, true);
				  $('#cbmeta').append(defmeta).trigger('change');
        }

        setTimeout(() => {
          if(this.vtipolanca === 1){//receita
            var defcateg  = new Option(this.editLancamento.descateg, this.vidcategoria, true, true);
            $('#cbcategoriareceita').append(defcateg).trigger('change');
          }else{
            var defcateg  = new Option(this.editLancamento.descateg, this.vidcategoria, true, true);
            $('#cbcategoriadespesa').append(defcateg).trigger('change');
          }
        }, 1000);

        var defconta  = new Option(this.editLancamento.descconta, this.vidconta, true, true);
				$('#cbconta').append(defconta).trigger('change');

        this.vdtlanca         = util.formatarDataBR(this.editLancamento.dtlancamento);
        this.vdescricaolanto  = this.editLancamento.desclancto;
    }
  },
  mounted(){
    let vself = this;
      $("#cbdespesa").select2({
          id: function (e) { return e.codfil },
          ajax: {
            url: util.servidor + '/controller/select2sql.php',
            dataType: 'json',
            delay: 250,
            data: function (params) {
              return {
                q: params.term,
                sqlini: 'select pl.id, pl.descricao from tbperfislancamento pl ' +
                        'left join tbcategorias c ON c.id = pl.idcategoria ',
                sqlfim: 'where upper(pl.descricao) like upper("%@@%") and c.tipo = 0 and c.idusuario =' + localStorage.getItem('iduser'),
                cpid: 'id',
                cpdesc: 'descricao'
              };
            },
            processResults: function (data) {
              return {
                results: data
              };
            },
            cache: true
          },
          minimumInputLength: 0,
          theme: 'bootstrap',
          language: "pt-BR",
          templateResult: util.formatResult,
          templateSelection: util.formatSelection
      }).change(function () {
        vself.vidreceitadespesa = $("#cbdespesa").val();
        
      });
      $("#cbreceita").select2({
        id: function (e) { return e.codfil },
        ajax: {
          url: util.servidor + '/controller/select2sql.php',
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              sqlini: 'select pl.id, pl.descricao from tbperfislancamento pl ' +
                      'left join tbcategorias c ON c.id = pl.idcategoria ',
              sqlfim: 'where upper(pl.descricao) like upper("%@@%") and c.tipo = 1 and c.idusuario =' + localStorage.getItem('iduser'),
              cpid: 'id',
              cpdesc: 'descricao'
            };
          },
          processResults: function (data) {
            return {
              results: data
            };
          },
          cache: true
        },
        minimumInputLength: 0,
        theme: 'bootstrap',
        language: "pt-BR",
        templateResult: util.formatResult,
        templateSelection: util.formatSelection
      }).change(function () {
        vself.vidreceitadespesa = $("#cbreceita").val();

        
      });
      $("#cbconta").select2({
        id: function (e) { return e.codfil },
        ajax: {
          url: util.servidor + '/controller/select2sql.php',
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              sqlini: 'select id, descricao from tbcontas ',
              sqlfim: 'where upper(descricao) like upper("%@@%") and idusuario =' + localStorage.getItem('iduser'),
              cpid: 'id',
              cpdesc: 'descricao'
            };
          },
          processResults: function (data) {
            return {
              results: data
            };
          },
          cache: true
        },
        minimumInputLength: 0,
        theme: 'bootstrap',
        language: "pt-BR",
        templateResult: util.formatResult,
        templateSelection: util.formatSelection
      }).change(function () {
        vself.vidconta = $("#cbconta").val();

        if (vself.vidconta) {
          let filtro = ' and c.id=' + vself.vidconta;
          let parametros = [
            { parametro: 'op', valor: 'listagem' },
            { parametro: 'idusuario', valor: localStorage.getItem('iduser') },
            { parametro: 'filtro', valor: filtro },
            { parametro: 'limit', valor: '99999' },
            { parametro: 'offset', valor: '0' },
          ];
          let retorno = util.reqaxios(parametros, 'post', util.servidor + '/controller/cadcofrescontas.php');
          retorno.then(function (response) {
            vself.saldoconta = parseFloat(response.data[0].saldo);
          }).catch(function (response) {

          });
        }

      });
      $("#cbcategoriareceita").select2({
        id: function (e) { return e.codfil },
        ajax: {
          url: util.servidor + '/controller/select2sql.php',
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              sqlini: 'select id, nome from tbcategorias ',
              sqlfim: 'where upper(nome) like upper("%@@%") and tipo = 1 and idusuario =' + localStorage.getItem('iduser'),
              cpid: 'id',
              cpdesc: 'nome'
            };
          },
          processResults: function (data) {
            return {
              results: data
            };
          },
          cache: true
        },
        minimumInputLength: 0,
        theme: 'bootstrap',
        language: "pt-BR",
        templateResult: util.formatResult,
        templateSelection: util.formatSelection
      }).change(function () {
        vself.vidcategoria = $("#cbcategoriareceita").val();
      });
      $("#cbcategoriadespesa").select2({
        id: function (e) { return e.codfil },
        ajax: {
          url: util.servidor + '/controller/select2sql.php',
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              sqlini: 'select id, nome from tbcategorias ',
              sqlfim: 'where upper(nome) like upper("%@@%") and tipo = 0 and idusuario =' + localStorage.getItem('iduser'),
              cpid: 'id',
              cpdesc: 'nome'
            };
          },
          processResults: function (data) {
            return {
              results: data
            };
          },
          cache: true
        },
        minimumInputLength: 0,
        theme: 'bootstrap',
        language: "pt-BR",
        templateResult: util.formatResult,
        templateSelection: util.formatSelection
      }).change(function () {
        vself.vidcategoria = $("#cbcategoriadespesa").val();
      });
      $("#cbmeta").select2({
        id: function (e) { return e.codfil },
        ajax: {
          url: util.servidor + '/controller/select2sql.php',
          dataType: 'json',
          delay: 250,
          data: function (params) {
            return {
              q: params.term,
              sqlini: 'select id, descricao from tbmetas ',
              sqlfim: 'where upper(descricao) like upper("%@@%")  and idusuario =' + localStorage.getItem('iduser'),
              cpid: 'id',
              cpdesc: 'descricao'
            };
          },
          processResults: function (data) {
            return {
              results: data
            };
          },
          cache: true
        },
        minimumInputLength: 0,
        theme: 'bootstrap',
        language: "pt-BR",
        templateResult: util.formatResult,
        templateSelection: util.formatSelection
      }).change(function () {
        vself.vidmeta = $("#cbmeta").val();
      });


      vself.igualardados()
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
.modal-wrapper {
  width: 100%;
  max-width: 500px;
}
.modal-container {
  background: white;
  padding: 20px;
  border-radius: 8px;
}
.modal-footer {
  margin-top: 20px;
  text-align: right;
}
.modal-footer button {
  margin-left: 10px;
}

</style>
